import React from 'react';
import styles from './index.module.scss';

export const TimeReference = (times: Number[]) => (
    <div className={`mr-1  ${styles.timetable_times}`}>
        {times.map((timeofDay: any) => (<div className={styles.timeslotTime} key={timeofDay}> <span>{timeofDay} <span className={"text-xs"}>00</span></span> </div>))}
    </div>
)